import React, { Component, Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { thousandSeparator } from '../../utils/Utils'
import { CiclePlus, CicleMinus, Rub } from '../app-icon/Icons'

// Import React Table
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import './m-table.css'

import withFixedColumns from 'react-table-hoc-fixed-columns'
import 'react-table-hoc-fixed-columns/lib/styles.css'

const ReactTableFixedColumns = withFixedColumns(ReactTable)

const styles = theme => ({
  tableWrapper: {
    maxWidth: '100%',
    margin: '0 10px 20px 10px',
    borderRadius: '8px',
    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.1)',
    backgroundColor: '#fff',
    overflow: 'hidden',
    paddingBottom: 16,
  },
  tableTitle: {
    fontSize: '14px',
    textAlign: 'center',
    padding: '15px 0',
  },
  settingTitle: {
    display: 'flex',
    alignItems: 'center',
  },
  hint: { width: 280 },
  hintIcon: {
    position: 'absolute',
    top: 10,
    right: 10,
    // display: 'block',
    display: 'none',
    width: 24,
    height: 24,
    border: '1px solid rgb(136, 102, 255)',
    borderRadius: '50%',
    lineHeight: '23px',
    color: 'rgb(255, 255, 255)',
    fontWeight: 600,
    cursor: 'pointer',
    backgroundColor: 'rgb(136, 102, 255)',
    textAlign: 'center',
  },
  hintHelp: {
    textAlign: 'left !important',
    whiteSpace: 'normal !important',
    padding: '4px 8px',
  },
})

class MTableAdvancedV2 extends Component {
  state = {
    data: this.props.data,
    resized: [],
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.data !== this.props.data) {
      this.setState({
        data: this.props.data,
        currency: this.props.currency,
      })
    }
  }

  _handleResizeChange = resized => {
    this.setState({ resized })
  }

  _renderSubComponent = props => (
    <NestedTable
      {...props}
      resized={this.state.resized}
      parentState={this.state}
      parentProps={this.props}
      columns={this.props.data.columns}
      currency={this.props.currency}
    />
  )

  render() {
    const { classes, settings, currency } = this.props
    const {
      data: { rows, columns },
    } = this.state

    const tableColumns = columns.map(({ header, columns, isDefault }) => {
      let sourceColumn = []

      const widthColumn = (title, minWidth) => {
        switch (title) {
          case 'source':
            return 400
          case 'users':
            return 110
          case 'cost':
            return 120
          default:
            return minWidth
        }
      }

      const expander = {
        Header: '',
        expander: true,
        width: 26,
        filterable: false,
        sortable: false,
        resizable: false,
        Expander: ({ isExpanded, ...rest }) => (
          <div className="mainRow">
            {isExpanded ? (
              <div className="circle">
                <CicleMinus width={16} height={16} fill={'#8866ff'} />
              </div>
            ) : (
              <div className="circle">
                <CiclePlus width={16} height={16} fill={'#8866ff'} />
              </div>
            )}
          </div>
        ),
      }

      const renderSymbol = type => {
        switch (type) {
          case '%':
            return '%'
          case '₽':
            return currency
          default:
            return ''
        }
      }

      const title = title => {
        switch (title) {
          case 'Затраты на рекламу':
            return 'Затраты\n на рекламу'
          default:
            return title
        }
      }

      if (header === 'Источники') {
        sourceColumn = [
          expander,
          ...columns.map(({ header, id }) => {
            return {
              Header: header,
              id,
              accessor: d => d[id],
              width: 400,
              resizable: false,
              Cell: ({ value }) => value,
              getProps: (state, rowInfo, column) => {
                return {
                  style: {
                    justifyContent: 'flex-start',
                  },
                }
              },
              filterable: false,
              Footer: () => <div>Общий итог</div>,
            }
          }),
        ]
      }

      const mainColumns = columns
        .filter(({ id }) => id !== 'source')
        .map(({ header, id, symbol }) => {
          return {
            Header: title(header),
            id,
            accessor: d => {
              return !isDefault ? Number(d[id]) : '-'
            },
            width: widthColumn(id, this.minWidth),
            minWidth: 90,
            Cell: ({ value }) => {
              return !isDefault ? (
                <span>
                  {thousandSeparator(value)}
                  {renderSymbol(symbol)}
                </span>
              ) : (
                '-'
              )
            },
            filterable: false,
            Footer: () =>
              !isDefault ? (
                <div>
                  {thousandSeparator(this.props.data.summary[id])}
                  {renderSymbol(symbol)}
                </div>
              ) : (
                '-'
              ),
          }
        })

      return {
        Header: isDefault ? (
          <span className={classes.settingTitle}>
            {header}
            {settings}
          </span>
        ) : (
          header
        ),
        fixed: header === 'Источники' ? 'left' : null,
        columns: [...sourceColumn, ...mainColumns],
      }
    })

    return (
      <div className={classes.tableWrapper}>
        <div className={classes.tableTitle}>Отчет по источникам трафика</div>

        {
          <React.Fragment>
            <ReactTableFixedColumns
              data={rows}
              pageSize={rows.length}
              showPagination={false}
              resizable={true}
              onResizedChange={this._handleResizeChange}
              SubComponent={this._renderSubComponent}
              columns={tableColumns}
              defaultSorted={[
                {
                  id: 'cost',
                  desc: true,
                },
              ]}
              noDataText="Нет данных"
              style={{ height: 522 }}
              className="-striped -highlight"
            />
          </React.Fragment>
        }
      </div>
    )
  }
}

class NestedTable extends Component {
  createColumns = (options = []) => {
    const columns = this.props.columns.map(({ header, columns, isDefault }) => {
      let sourceColumn = []

      const widthColumn = (title, minWidth) => {
        switch (title) {
          case 'source':
            return 400
          case 'users':
            return 110
          case 'cost':
            return 120
          default:
            return minWidth
        }
      }

      const renderSymbol = type => {
        switch (type) {
          case '%':
            return '%'
          case '₽':
            return this.props.currency
          default:
            return ''
        }
      }

      if (header === 'Источники') {
        sourceColumn = options
      }

      const mainColumns = columns
        .filter(({ id }) => id !== 'source')
        .map(({ header, id, symbol }) => {
          return {
            Header: header,
            id,
            accessor: d => {
              return !isDefault ? Number(d[id]) : '-'
            },
            width: widthColumn(id, this.minWidth),
            minWidth: 90,
            Cell: ({ value }) => {
              return !isDefault ? (
                <span>
                  {thousandSeparator(value)}
                  {renderSymbol(symbol)}
                </span>
              ) : (
                '-'
              )
            },
            filterable: false,
          }
        })

      return {
        Header: header,
        fixed: header === 'Источники' ? 'left' : null,
        columns: [...sourceColumn, ...mainColumns],
      }
    })

    return columns
  }

  render() {
    const { rows } = this.props.original
    const { resized } = this.props

    const options = [
      {
        width: 26,
        Header: '',
        resizable: false,
      },
      {
        Header: '',
        width: 400,
        expander: true,
        filterAll: false,
        resizable: false,
        className: 'firstLevel',
        Expander: ({ isExpanded, ...rest }) => {
          if (rest.original.rows == null || rest.original.rows.length == 0) {
            return (
              <div className="subRow">
                <div
                  className="tablePoint"
                  style={{ cursorPointer: 'none' }}
                ></div>
                <div className="source-title">{rest.original.source}</div>
              </div>
            )
          }
          return (
            <div className="subRow">
              <div className="table-toggle">
                {isExpanded ? (
                  <div className="circle">
                    <CicleMinus width={16} height={16} fill={'#8866ff'} />
                  </div>
                ) : (
                  <div className="circle">
                    <CiclePlus width={16} height={16} fill={'#8866ff'} />
                  </div>
                )}
              </div>
              <div className="source-title">{rest.original.source}</div>
            </div>
          )
        },
        getProps: (state, rowInfo, column) => {
          if (rowInfo) {
            if (
              rowInfo.original.rows == null ||
              rowInfo.original.rows.length == 0
            ) {
              return {
                onClick: () => {},
              }
            }
          }
          return {
            style: {
              padding: 0,
            },
          }
        },
      },
    ]

    return (
      <ReactTableFixedColumns
        data={rows}
        pageSize={rows.length}
        showPagination={false}
        resized={resized}
        columns={this.createColumns(options)}
        className="subTable"
        SubComponent={row => {
          const { rows } = row.original
          const options = [
            {
              width: 26,
              Header: '',
              resizable: false,
            },
            {
              Header: '',
              width: 400,
              expander: true,
              filterAll: false,
              resizable: false,
              className: 'secondLevel',
              Expander: ({ isExpanded, ...rest }) => {
                if (
                  rest.original.rows == null ||
                  rest.original.rows.length == 0
                ) {
                  return (
                    <div className="subRow">
                      <div
                        className="tablePoint"
                        style={{ cursorPointer: 'none' }}
                      ></div>
                      <div className="source-title">{rest.original.source}</div>
                    </div>
                  )
                }
                return (
                  <div className="subRow">
                    <div className="table-toggle">
                      {isExpanded ? (
                        <div className="circle">
                          <CicleMinus width={16} height={16} fill={'#8866ff'} />
                        </div>
                      ) : (
                        <div className="circle">
                          <CiclePlus width={16} height={16} fill={'#8866ff'} />
                        </div>
                      )}
                    </div>
                    <div className="source-title">{rest.original.source}</div>
                  </div>
                )
              },
              getProps: (state, rowInfo, column) => {
                if (rowInfo) {
                  if (
                    rowInfo.original.rows == null ||
                    rowInfo.original.rows.length == 0
                  ) {
                    return {
                      onClick: () => {},
                    }
                  }
                }
                return {
                  style: {
                    padding: 0,
                  },
                }
              },
            },
          ]
          return (
            <ReactTableFixedColumns
              data={rows}
              pageSize={rows.length}
              showPagination={false}
              resized={resized}
              className="subTable"
              columns={this.createColumns(options)}
              SubComponent={row => {
                const { rows } = row.original
                const options = [
                  {
                    width: 26,
                    Header: '',
                    resizable: false,
                  },
                  {
                    Header: '',
                    id: 'source',
                    resizable: false,
                    accessor: d => d.source,
                    width: 400,
                    filterAll: false,
                    Cell: row => {
                      return (
                        <div className="subRow">
                          <div className="tablePoint"></div>
                          <div className="content-title">
                            {`${row.original.source}`}
                          </div>
                        </div>
                      )
                    },
                    getProps: (state, rowInfo, column) => {
                      return {
                        className: 'thirdLevel',
                      }
                    },
                  },
                ]
                return (
                  <ReactTableFixedColumns
                    data={rows}
                    pageSize={rows.length}
                    showPagination={false}
                    resized={resized}
                    className="subTable"
                    columns={this.createColumns(options)}
                  />
                )
              }}
            />
          )
        }}
      />
    )
  }
}

export default withStyles(styles)(MTableAdvancedV2)
